import { SensorCalibrationChip } from 'components'
import { UserSettingsSection } from './UserSettingsSection'

export const SensorCalibration = () => {
  const sensorCalibrationCell = <SensorCalibrationChip editable />

  const rows = [{ label: 'Calibration', cells: [sensorCalibrationCell] }]
  return <UserSettingsSection header="Sensor" rows={rows} />
}
